export class AdjusmentNoteRequest{
    debitNote:string;
    tab:string
    
    constructor( debitNote:string,tab:string){
        this.debitNote = debitNote;
        this.tab = tab
    }
}